import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import { Form, Row, Col, Container, Button, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useStateValue } from '../../utilities/StateProvider';

function StepTwo(props) {

    const [{ event }, dispatch] = useStateValue();

    useEffect(() => {
        const savedEvent = JSON.parse(sessionStorage.getItem('event'));

        if (savedEvent) {
            dispatch({
                type: 'setEvent',
                event: savedEvent
            });
        }

    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        
        const newEvent = {
            ...event,
            address: form.address.value,
            date: form.date.value,
            hour: form.hour.value,
            ampm: form.ampm.value,
            quantity: form.quantity.value,
            type: form.type.value,
            contact: {
                name: form.contactName.value,
                lastname: form.contactLastname.value,
                phone: form.contactPhone.value
            }
        }

        sessionStorage.setItem('event', JSON.stringify(newEvent));

        dispatch({
            type: 'setEvent',
            event: newEvent
        });

        props.history.push('/resume');

    }

    const { name, lastname, phone } = !!event.contact && event.contact;

    return (
        <Container>
            <Form className="step-form" onSubmit={handleSubmit}>
                <Row>
                    <Col className="step-header">
                        <div className="title">Cuéntanos sobre tu Evento</div>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="4">
                        <Form.Control name="address" placeholder="Dirección de entrega" required defaultValue={event.address}/>
                    </Col>
                    <Col xs="12" md="4">
                        <OverlayTrigger
                            trigger="hover"
                            placement="top"
                            delay={{ show: 100, hide: 250 }}
                            overlay={
                                props => (<Tooltip id="date-tooltip" {...props}>Fecha del Evento</Tooltip>)
                            }
                        >
                            <Form.Control name="date" type="date" placeholder="Fecha DD/MM/AAAA" required defaultValue={event.date} />
                        </OverlayTrigger>
                    </Col>
                    <Col xs="12" md="4">
                        <InputGroup>
                            <Form.Control name="hour" placeholder="Hora del Evento" required defaultValue={event.hour}/>
                            <InputGroup.Append>
                                <Form.Control name="ampm" as="select" defaultValue="pm">
                                    <option>AM</option>
                                    <option>PM</option>
                                </Form.Control>
                            </InputGroup.Append>
                        </InputGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="6">
                        <Form.Control name="quantity" placeholder="Cantidad de personas" required defaultValue={event.quantity}/>
                    </Col>
                    <Col xs="12" md="6">
                        <Form.Control name="type" placeholder="Tipo de evento" required defaultValue={event.type}/>
                    </Col>
                </Row>
                <Row>
                    <Col className="step-header">
                        <div className="title">Datos de contacto</div>
                        <div className="subtitle">
                            (Datos de la persona contacto en el evento)
                            <br/>
                            Ejemplo wedding planner
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="4">
                        <Form.Control name="contactName" placeholder="Nombre" required defaultValue={name}/>
                    </Col>
                    <Col xs="12" md="4">
                        <Form.Control name="contactLastname" placeholder="Apellido" required defaultValue={lastname}/>
                    </Col>
                    <Col xs="12" md="4">
                        <Form.Control name="contactPhone" placeholder="Teléfono" required defaultValue={phone}/>
                    </Col>
                </Row>
                <Button className="shop-button" onClick={props.prev}>Atrás</Button>
                <Button className="shop-button fill" type="submit">Generar Orden</Button>
            </Form>
        </Container>
    )
}

export default withRouter(StepTwo);
